import React from 'react';
import { Link } from 'react-router-dom';
import arrow_back from '../assets/images/arrow-back.svg';
import logo_pop from '../assets/images/logo-pop.png';
import searcher from '../assets/images/searcher.png';
import EDSFooter from '../components/EDSFooter';

const Error_nie_znaleziono_uzytkownika = () => {
    return (
        <>
            <header className="header">
                <div className="header__image-box">
                    <a href="">
                        <img
                            src={logo_pop}
                            alt="Logo Egurrola Dance Studio"
                            className="header__image"
                        />
                    </a>
                </div>
                <div className="header__caption-box">
                    <span className="header__caption">Proces zakupu kursu</span>
                </div>
            </header>
            <div className="content responsive-padding margin-top-32">
                <div className="half-half half-half--text-to-left">
                    <main className="">
                        <div style={{ display: 'none' }}>
                            <a href="">
                                <img src={arrow_back} alt="arrow_back" className="arrow-back" />
                            </a>
                        </div>
                        <section className="margin-top-64 margin-bottom-32">
                            <h2 className="h2">
                                Oops!<br></br>Nie znaleziono użytkownika / nieaktywne konto.
                            </h2>
                            <p className="margin-top-32">Spróbuj odzyskać hasło jeszcze raz</p>
                            <Link to="/Odzyskaj_haslo">
                                <a
                                    href=""
                                    className="btn-primary-responsive btn-primary-responsive--medium margin-top-16"
                                >
                                    Odzyskaj hasło
                                </a>
                            </Link>
                            <p className="margin-top-64">lub skontaktuj się z naszą Infolinią.</p>
                            <h2 className="h2 margin-top-16">INFOLINIA</h2>
                            <p className="margin-top-8">czynna od poniedziałku do piątku</p>
                            <p>w godzinach 9:00 - 17:00</p>
                            <p className="margin-top-16">tel.: 601 20 20 20</p>
                            <p>e-mail: studio@egurrola.pl</p>
                            <Link to="/">
                                <a
                                    href=""
                                    className="btn-secondary-responsive btn-secondary-responsive--medium margin-top-64"
                                >
                                    Wróć do strony głównej
                                </a>
                            </Link>
                        </section>
                    </main>
                    <div className="decorative">
                        <img
                            src={searcher}
                            alt="Mężczyzna z lupą w ręce."
                            className="decorative__img--vertical"
                        />
                    </div>
                </div>
            </div>
            <EDSFooter></EDSFooter>
        </>
    );
};
export default Error_nie_znaleziono_uzytkownika;
